import React from 'react';
import './App.css'; // Import the CSS file for styling

function App() {
  return (
    <div className="App">
      <h1>Welcome to Balancve</h1>
      <p>Discover my latest creations on the App Store and Google Play.</p>

      <div className="link-section">
        {/* Example App Store Link - Replace with your actual links! */}
        <a href="https://apps.apple.com/au/developer/balancve/id1829106836" target="_blank" rel="noopener noreferrer" className="app-link">
          Download on the App Store
        </a>

        {/* Example Google Play Link - Replace with your actual links! */}
        <a href="https://play.google.com/store/apps/developer?id=Balancve" target="_blank" rel="noopener noreferrer" className="app-link">
          Get it on Google Play
        </a>
        {/* Add more links as needed following the same pattern */}
      </div>

      <p className="contact-info">
        For support and inquiries, please contact us: <br />
        <a href="mailto:help@balancve.com">help@balancve.com</a>
      </p>
    </div>
  );
}

export default App;
